export default __webpack_public_path__ + "static/media/ig.fa3c08c2.svg";